var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4667 14V18.3835H2.53333V14H0V19.8447C0 20.6529 0.567625 21.3059 1.26667 21.3059H17.7333C18.434 21.3059 19 20.6529 19 19.8447V14H16.4667Z",
    fill: "#526F65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3962 6.00404C14.2905 6.23249 14.0577 6.37801 13.8016 6.37801H11.1878V14.6707C11.1878 15.0227 10.895 15.3086 10.5344 15.3086H7.92064C7.56002 15.3086 7.2672 15.0227 7.2672 14.6707V6.37801H4.65344C4.39738 6.37801 4.16459 6.23129 4.05881 6.00404C3.95181 5.7756 3.99347 5.50887 4.16214 5.3203L8.73622 0.217106C8.86037 0.0779638 9.03925 -0.000976562 9.22752 -0.000976562C9.41579 -0.000976562 9.59467 0.0795584 9.71882 0.217106L14.2929 5.3203C14.4628 5.50808 14.502 5.77599 14.3962 6.00404Z",
    fill: "#526F65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.f11f6733bee0388f5a9e7874351c626c.svg";
export { ForwardRef as ReactComponent };